import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectCoopMaxLevel = memoize(function () { return utilBalancing.getBalancing().CoopLevels.size; });
export var selectPlayerLevels = function () { return utilBalancing.getBalancing().PlayerLevels; };
export var selectPlayerLevelFromXp = memoize(function (xp) {
    var PlayerLevels = selectPlayerLevels();
    var currentLevel;
    var nextLevel = PlayerLevels.get(1);
    do {
        currentLevel = nextLevel;
        nextLevel = PlayerLevels.get(currentLevel.level + 1);
    } while (nextLevel !== undefined && xp.greaterThanOrEqual(nextLevel.requiredXp));
    return currentLevel.level;
});
export var selectPlayerLevelInfo = memoize(function (level) { return selectPlayerLevels().get(level); });
export var selectCoopLevels = memoize(function () { return utilBalancing.getBalancing().CoopLevels; });
export var balancingXpLevelsMemoizedFunctions = [
    selectCoopMaxLevel,
    selectPlayerLevels,
    selectPlayerLevelFromXp,
    selectPlayerLevelInfo,
    selectCoopLevels,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingXpLevels.ts
// module id = 170
// module chunks = 3